/**
 * The order ledger (v0.1.254, migration 0135): GET /ledger. One row per Etsy order (net subtotal, estimated Etsy fees,
 * ad share, refund flag, channel) and the contribution of the last 7 and 28 days, all computed by SQL; plus this month's
 * Genesis money set against the figure Genesis reports. Amounts in cents (micro dollars for the AI money).
 */
import { z } from 'zod';
export const contributionSchema = z.object({
    /** The period, [from, to) in epoch ms. */
    from: z.number().int(),
    to: z.number().int(),
    orders: z.number().int(),
    netCents: z.number().int(),
    /** Etsy fees, an estimate from the fee schedule. */
    feesCents: z.number().int(),
    refundCents: z.number().int(),
    adCents: z.number().int(),
    /** Twin's own AI and API spend in the period (twin.costs, real money only). */
    aiCents: z.number().int(),
    contributionCents: z.number().int(),
    /** Orders whose channel is not known (no Share & Save, coupon or stored attribution). */
    unknownChannel: z.number().int(),
    /** Orders whose fixed 14 TRY fee part had no exchange rate (counted 0). */
    fxMissing: z.number().int(),
});
export const ledgerOrderSchema = z.object({
    receiptId: z.string(),
    orderedAt: z.number().int(),
    listingIds: z.array(z.string()),
    discountCents: z.number().int(),
    netCents: z.number().int(),
    feesCents: z.number().int(),
    feesAreEstimate: z.boolean(),
    adCents: z.number().int(),
    refunded: z.boolean(),
    channel: z.string(),
    couponCode: z.string().nullable(),
});
export const genesisReconciliationSchema = z.object({
    monthStart: z.string(),
    twinMicroUsd: z.number().int(),
    /** The Google search share inside Twin's total (whether Genesis's own figure includes it is not known). */
    searchMicroUsd: z.number().int(),
    /** Spend after Genesis's last usage reading, the search share left out. */
    afterReadingMicroUsd: z.number().int(),
    /** Genesis's figure for this month; null without a reading this month. */
    reportedMicroUsd: z.number().int().nullable(),
    reportedAt: z.number().int().nullable(),
    unexplainedMicroUsd: z.number().int(),
});
export const ledgerViewSchema = z.object({
    asOf: z.number().int(),
    week: contributionSchema,
    month: contributionSchema,
    /** The newest orders first (at most 100). */
    orders: z.array(ledgerOrderSchema),
    feeNote: z.string(),
    reconciliation: genesisReconciliationSchema,
});
//# sourceMappingURL=ledger.js.map